/* everstride-11 — o buybox replicado usa o form do concorrente; o JS do tema dele
   nao existe aqui, entao interceptamos o CLIQUE em captura (o submit nativo levaria
   a /cart) e abrimos a gaveta lateral do Shrine. */
(function () {
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    var icon = document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"]');
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    if (icon) icon.click();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('.cl-pdp-slot button[type="submit"]')
      : null;
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/?section_id=cart-drawer'); })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        var cur = document.querySelector('cart-drawer');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          cur.classList.remove('is-empty');
        }
        var bubble = doc.querySelector('#cart-icon-bubble');
        var curBubble = document.querySelector('#cart-icon-bubble');
        if (bubble && curBubble) curBubble.innerHTML = bubble.innerHTML;
        openDrawer();
      })
      .catch(function () { window.location = '/cart'; })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }, true);
})();
